/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { BoxKanban, ColumnKanban, ContainerKanban, TextKanban } from './Kanban.style';
import BusinessIcon from '@mui/icons-material/Business';
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PortraitIcon from '@mui/icons-material/Portrait';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PlaceIcon from '@mui/icons-material/Place';

import { DragDropContext, Draggable } from 'react-beautiful-dnd';
import { useEffect, useContext, useState } from 'react';
import Card from '../card/card.component';
import { StrictModeDroppable } from '../strictmodeDropabble/strictmodeDopable';
import { useApi } from '../../../hooks/userApi';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { Stack } from '@mui/material';
import { ItemsDetails, KabanDetailProps } from '../../../types/kanban';

import { formatDinheiro } from '../../../utils/formatDinheiro';

const api = useApi();

const KanbanComponent: React.FC<KabanDetailProps> = ({ dataKanban }) => {
  const { setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);
  const [data, setData] = useState(dataKanban);
  const [isExpande, setExpanded] = useState<boolean>(false);
  const [idItem, setIdItem] = useState<string>('');

  const atualizar = async (item: any, _status: any) => {
    const objBody = {
      status: _status,
    };

    await api
      .patch('/orcamento/' + item, objBody)
      .then((response) => {})
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColIndex = dataKanban.findIndex((e) => e.id === source.droppableId);
      const destionationColIndex = dataKanban.findIndex((e) => e.id === destination.droppableId);

      const sourceCol = dataKanban[sourceColIndex];
      const destionationCol = dataKanban[destionationColIndex];

      const sourceTask = [...sourceCol.items];
      const destionationTask = [...destionationCol.items];

      const [removed] = sourceTask.splice(source.index, 1);
      destionationTask.splice(destination.index, 0, removed);

      dataKanban[sourceColIndex].items = sourceTask;
      dataKanban[destionationColIndex].items = destionationTask;

      if (destionationColIndex === 0) {
        atualizar(removed.id, 'feito');
      } else if (destionationColIndex === 1) {
        atualizar(removed.id, 'enviado');
      } else if (destionationColIndex === 2) {
        atualizar(removed.id, 'follow');
      } else if (destionationColIndex === 3) {
        atualizar(removed.id, 'recusado');
      } else if (destionationColIndex === 4) {
        atualizar(removed.id, 'aprovado');
      } else if (destionationColIndex === 5) {
        atualizar(removed.id, 'atualizar');
      }

      setData(data);
    }
  };

  useEffect(() => {
    setData(dataKanban);
  }, [dataKanban]);

  const Calculo = (v: ItemsDetails[]) => {
    let totalFrete = 0;
    v.map((item) => {
      totalFrete = totalFrete + (Number(item.precoFinal) - Number(item.descontoFrete));
    });

    return totalFrete;
  };

  function handleExpande(item: any) {
    if (item) {
      if (idItem === item.id) {
        setExpanded(!isExpande);
      } else {
        setIdItem(item.id);
        setExpanded(true);
      }
    }
  }

  return (
    <Stack spacing={2} width="100%">
      {
        <DragDropContext onDragEnd={onDragEnd}>
          <ContainerKanban>
            {data.map((section) => (
              <StrictModeDroppable key={section.id} droppableId={section.id}>
                {(provided) => (
                  <BoxKanban {...provided.droppableProps} ref={provided.innerRef}>
                    <TextKanban primary>{section.title}</TextKanban>
                    <ColumnKanban>
                      <TextKanban secundary>
                        <TextKanban prefixo>Valor total</TextKanban>
                        <TextKanban conteudoPrefixo>{formatDinheiro(Calculo(section.items), 2)}</TextKanban>
                      </TextKanban>
                      <TextKanban secundary>
                        <TextKanban prefixoSecundary>Resultados:</TextKanban>
                        <TextKanban conteudoPrefixo contSecundary>
                          {section?.items.length}
                        </TextKanban>
                      </TextKanban>
                      {section.items.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                          {/* eslint-disable-next-line @typescript-eslint/no-shadow*/}
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                opacity: snapshot.isDragging ? '0.5' : '1',
                              }}
                            >
                              <Card onClick={() => handleExpande(item)} status={section.title ?? ''}>
                                <TextKanban icon>
                                  <BusinessIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />{' '}
                                  {item.cliente?.nome}
                                </TextKanban>
                                <TextKanban icon style={{ textTransform: 'uppercase', fontWeight: 800 }}>
                                  <>
                                    <MonetizationOnIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />
                                    {formatDinheiro(Number(item.precoFinal) - Number(item.descontoFrete), 2)}
                                  </>
                                </TextKanban>
                                {isExpande && idItem === item.id && (
                                  <>
                                    <TextKanban icon>
                                      <CallIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />{' '}
                                      {item.cliente?.telefone}
                                    </TextKanban>
                                    <TextKanban icon>
                                      <WhatsAppIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />{' '}
                                      {item.cliente?.whatsapp}
                                    </TextKanban>
                                    <TextKanban icon>
                                      <PortraitIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />{' '}
                                      {item.cliente?.razaoSocial}
                                    </TextKanban>
                                    <TextKanban icon>
                                      <CalendarTodayIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />
                                      {new Date(item.created_at).toLocaleDateString('pt-br')}
                                    </TextKanban>
                                    <TextKanban icon>
                                      <EventAvailableIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />
                                      {new Date(item.validade).toLocaleDateString('pt-br')}
                                    </TextKanban>
                                    <TextKanban icon>
                                      <PlaceIcon color="success" sx={{ fontSize: 16, marginRight: 2 }} />
                                      {item.cliente?.estado}
                                    </TextKanban>
                                  </>
                                )}
                              </Card>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </ColumnKanban>
                  </BoxKanban>
                )}
              </StrictModeDroppable>
            ))}
          </ContainerKanban>
        </DragDropContext>
      }
    </Stack>
  );
};

export default KanbanComponent;
